import React, { Component } from 'react'; 
import _ from 'lodash';
import {Table, Pagination, FormControl, InputGroup, Dropdown, DropdownButton} from 'react-bootstrap'
import ReAssign from './ReAssign';
import ViewModeSampling from './viewModeSampling';

function searchingFor(term, eventKey, subKey){ 
	return function(x){    
    if(_.isArray(x[eventKey])){
      let a = x[eventKey];
      let gg =[]
      _.map(a, (obj) =>{
        if(subKey !== null){
          gg.push(_.includes(obj[subKey].toLowerCase(), term.toLowerCase()))
        } else {
          gg.push(_.includes(obj.toLowerCase(), term.toLowerCase()))
        }
      })
      return _.includes(gg, true) || !term
    } else {
      return _.includes(x[eventKey].toLowerCase(), term.toLowerCase()) || !term;
    }
	}
}
export default class MappedList extends Component {
  constructor(props){
    super(props)
    this.state={
      activePage:1,
      term:'',
      eventKey:"templateName",
      subKey:''
    }
  }
  componentDidMount(){     
    this.props.action.TokenValidation()      
    this.props.action.mappingAction()
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
      this.props.action.mappingAction()   
    }
  } 

  handleSelectPagination = (eventKey) => {
    this.setState({
    activePage: eventKey,
    });
  }
  handleSelectPaginationPrev = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage-1,
    });
  }
  handleSelectPaginationNext = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage+1,
    });
  }	
  readMe = (prop,index) =>{
    this.setState({[prop+index]:true})
  }
  readMeClose = (prop,index) =>{
     this.setState({[prop+index]:false})
  }
  openModalView =(index) => {
		this.setState({['modalIsRead'+index]: true, });
	}
	
	closeModalView=(index) =>{
		this.setState({['modalIsRead'+index]: false, });
  }
  handleChange = (e) => {
		this.setState({term:e.target.value})	
  }
  searchFilter =(e, sub) =>{
    this.setState({eventKey:e, subKey:sub})
    if(!_.isEqual(this.state.eventKey, e)){
      this.setState({term:''})
    }
  }
  render(){
    const{action, mappedData, templates, auditTypes, accessPermission}= this.props;    
    let permission  = _.includes(accessPermission,'WRITE')
    const{activePage, term, eventKey, subKey} = this.state;
    const Per_Page=50;
    let startCount = 0;
    const startOffset = (this.state.activePage-1) * Per_Page;
    let items = [];
    let totalPages;
    if(!_.isEmpty(mappedData)){
     totalPages = Math.ceil(mappedData.length/Per_Page)         
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
    }
   }
    return(<div>
       <span className='alignRight'>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
            <DropdownButton
						 as={InputGroup.Append}
             alignRight
             variant="outline-secondary"
             title=""           
             id="dropdown-menu-align-right"
						>	
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, '')} eventKey="templateName" active={eventKey === "templateName"}  ><b>TEMPLATE NAME</b></Dropdown.Item>					
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'centerName')} eventKey="center" active={eventKey === "center"}  ><b>CENTER</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'clientName')} eventKey="client" active={eventKey === "client"}  ><b>CLIENT</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'processName')} eventKey="process" active={eventKey === "process"}  ><b>PROCESS</b></Dropdown.Item>            
            </DropdownButton>
				</InputGroup>
				</span>
      <Table responsive>
        <thead>
          <th>REGION</th>
          <th>CENTER</th>
          <th>CLIENT</th>
          <th>PROCESS</th>
          <th>TEMPLATE</th>
          <th>ACTIONS</th>
        </thead>
        <tbody>
          { !_.isEmpty(mappedData) ?            
            _.map(mappedData.filter(searchingFor(term, eventKey, subKey)), (obj, index)=>{
              if(index >= startOffset & startCount < Per_Page){
              startCount++;
            let tempval = {};
            tempval["templateName"] = obj.templateName;
            if(!_.isEmpty(obj.agentCategories)){
              tempval['agentCategories'] = obj.agentCategories 
            }
            if(!_.isEmpty(obj.callDurations)){
              tempval['callDurations'] = obj.callDurations 
            }
            if(!_.isEmpty(obj.callMixCategories)){
              tempval['callMixCategories'] = obj.callMixCategories 
            }
            if(!_.isEmpty(obj.callNatures)){
              tempval['callNatures'] = obj.callNatures 
            }
            return(
            <tr>
              <td>{obj.region.regionName}</td>
              <td>{_.map(obj.center, (item, index) => {return item.centerName }).join(',') }</td>
              <td>{_.map(obj.client, (item, index) => {return item.clientName }).join(',') }</td>
              <td>{_.map(obj.process, (item, index) => {return item.processName }).join(',') }</td>
              <td>{obj.templateName}</td>
              <td className='readMe'> 
              {(permission === true) ?
              <span>               
              {/* <i class='fas fa-pen' onClick={()=>this.readMe('readme',index)}/>
                {this.state['readme'+index] ? 
               <SamplingLogic  closeModal={()=>this.readMeClose('readme', index)}
							 action={action} edit={true}
               templates={tempval} 
               fullTemplate={templates}
							 durationProp={durationProp} />                 
                : null}   */}
              <i class="fas fa-link" onClick={()=>this.readMe('link', index)} />
              {this.state['link'+index] ? 
              <ReAssign link={true} closeModal={()=>this.readMeClose('link', index)}
              action={action} templates={templates}  data={obj}/>             
              : null}
            </span> : null}
            <i class='fas fa-eye' onClick={()=>this.openModalView(index)}/>
						{this.state['modalIsRead'+index] ?
						<ViewModeSampling closeModal={()=>this.closeModalView(index)} auditTypes={auditTypes} data={obj}/> : null}
            </td>
            </tr>)
          }
          }) 
          : <tr><td colSpan="6">No Record Found</td></tr>
          }
        </tbody>
        </Table>
        <Pagination>
      <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
      <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
      <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
      <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
      </Pagination>
      </div>)
    
   
  }
    
}
